export enum CardStatusOption {
  COMPLETED = '3b3ca704-d281-11eb-b8bc-0242ac130003',
  NOT_COMPLETED = '3b3ca9f2-d281-11eb-b8bc-0242ac130003',
}
